import { useBlockContext } from './BlockContext';
export function useBlockParams() {
  var _useBlockContext = useBlockContext(),
    block = _useBlockContext.block;
  return block === null || block === void 0 ? void 0 : block.blockParameters;
}
export function useBlockRID() {
  var _useBlockContext2 = useBlockContext(),
    block = _useBlockContext2.block;
  return block === null || block === void 0 ? void 0 : block.blockRID;
}